import { SubGroupConfiguration } from "../../data";
export const SubGroupFunctions = {
    [SubGroupConfiguration.None]: {
        headings: "",
        events: "displayEventByMainGrouping"
    },
    [SubGroupConfiguration.League]: {
        headings: "displayLeagues",
        events: "displayEventsByLeague"
    },
    [SubGroupConfiguration.Time]: {
        headings: "displayHours",
        events: "displayEventsByTime"
    }
};
//# sourceMappingURL=SubGroupFunctions.js.map